module.exports = __webpack_public_path__ + "img/HIDE.f2b8c525.svg";